export const DisableLink = () => {
	const disabledLinks = document.getElementsByClassName('disabled-link');

	if (disabledLinks) {
		for (let i = 0; i < disabledLinks.length; i++) {
			disabledLinks[i].addEventListener('click', function (event) {
				event.preventDefault();
			});
		}
	}
};
